export interface IQuery { }

export class ConnectorDataStreamsQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Integrations.Connectors.Queries.ConnectorDataStreamsQueryV1, TCh.Domain.Integrations'

	ConnectorId: string

	constructor (connectorId: string)
	{
		this.ConnectorId = connectorId
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Integrations.Connectors.Queries.ConnectorDataStreamsQueryV1, TCh.Domain.Integrations'
	}

}

export class ConnectorDetailsQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Integrations.Connectors.Queries.ConnectorDetailsQueryV1, TCh.Domain.Integrations'

	ConnectorId: string

	constructor (connectorId: string)
	{
		this.ConnectorId = connectorId
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Integrations.Connectors.Queries.ConnectorDetailsQueryV1, TCh.Domain.Integrations'
	}

}

export class ConnectorPropertyNamesQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Integrations.Connectors.Queries.ConnectorPropertyNamesQueryV1, TCh.Domain.Integrations'

	ConnectorId: string
	DataStream: string

	constructor (connectorId: string, dataStream: string)
	{
		this.ConnectorId = connectorId
		this.DataStream = dataStream
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Integrations.Connectors.Queries.ConnectorPropertyNamesQueryV1, TCh.Domain.Integrations'
	}

}

export class ConnectorProvidersQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Integrations.Connectors.Queries.ConnectorProvidersQueryV1, TCh.Domain.Integrations'

	CanRead: boolean
	CanWrite: boolean

	constructor (canRead: boolean, canWrite: boolean)
	{
		this.CanRead = canRead
		this.CanWrite = canWrite
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Integrations.Connectors.Queries.ConnectorProvidersQueryV1, TCh.Domain.Integrations'
	}

}

export class ConnectorsOfOrganizationQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Integrations.Connectors.Queries.ConnectorsOfOrganizationQueryV1, TCh.Domain.Integrations'

	OrganizationUnitId: string
	Rebuild: boolean

	constructor (organizationUnitId: string, rebuild: boolean)
	{
		this.OrganizationUnitId = organizationUnitId
		this.Rebuild = rebuild
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Integrations.Connectors.Queries.ConnectorsOfOrganizationQueryV1, TCh.Domain.Integrations'
	}

}

